import api from "../api"
import { getSession } from "../auth"
import useNotification from "../components/Notification"

const tokenTimeout = 30000
let token: null | String = null

const getToken = async () => {
    const res = await api.get(`api/oauth/authenticate/`)
        if (res.status !== 200){
            useNotification(
                'Ops!', 'Falha ao gerar o token', 'danger'
            )
            return
        }
    token = res.data
    setTimeout(() => token = null, tokenTimeout)
    return token
}

type RequestParams = { 
    url: string;
    method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'; 
    provider: 'MICROSOFT_CALENDAR' | 'GOOGLE_CALENDAR'; 
    email: string;
    user_id: string;
    body?: any
 };

const request = async ({url, method, provider, email, user_id, body} : RequestParams, enterpriseId: string) => {
    
    const redirect = await fetch(`/external/redirect/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            key: token,
            url: url,
            method: method,
            enterprise: enterpriseId,
            user_id: user_id,
            provider: provider,
            email: email,
            body: body
        }),    
    })

    if (redirect.status === 204)
        return {status_code: redirect.status}
    return {...(await redirect.json()), status_code: redirect.status}

    if ([200, 201].includes(redirect.status))
        return await redirect.json()

    return redirect.json()
} 

const oauthRequest = async (requestList: Array<RequestParams>) => {

    const enterpriseId = getSession()?.profile?.enterprise?.id
    if (token) {
        return Promise.all(requestList.map(args => request(args, enterpriseId)))
    } else {
        if (await getToken())
            return oauthRequest(requestList)
    }

}

export const oauthSingleRequest = async (args: RequestParams) => {
    const [res] = await oauthRequest([args])
    return res
}

export default oauthRequest
